export function castEnumForDisplay(
  rawEnum: string | null | undefined,
): string | null {
  if (!rawEnum) {
    return null;
  }

  const withSpaces = rawEnum.replace(/_/g, " ").toLowerCase();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

/**
 * Formats a solver status string (e.g., "SOLVING_ACTIVE") into
 * a human-readable display string ("Solving active").
 */
export function castSolverStatusForDisplay(
  solverStatus: string | null | undefined,
): string {
  if (!solverStatus) return "N/A";
  const withSpaces = solverStatus.replace(/_/g, " ").toLowerCase();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

/**
 * Formats a blood group enum value (e.g., "A_POSITIVE") into
 * a human-readable format ("A POSITIVE").
 */
export const formatBloodGroup = (bg: string | null | undefined): string => {
  if (!bg) return "N/A";
  return bg.replace(/_/g, " ");
};
